let ajaxState = false;

const searchHandler = () => {
    $('.btn-search').on('click', function (e) {
        console.log('fff');
        e.preventDefault();
        $('.header-search').addClass('open'); 
        $('body').addClass('overflow-hidden');    
    });

    $('.icon-close').on('click', function (e) {
        $('.header-search').removeClass('open'); 
        $('body').removeClass('overflow-hidden');      
    });
};

const mediaModal = () => {
    let videoModalTpl = `
            <div class="modal fade media-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button class="button-close" type="button" data-dismiss="modal" aria-label="Close">
                            <i class="icon-cross"></i>
                        </button>
                        <div class="modal-body p-0"></div>
                    </div>
                </div>
            </div>
        `;
    $(document).on('click', '.media-video a, .has-zoom a',function(e) {
        e.preventDefault();
        let src = $(e.target).parent().data('src');
        let type = $(e.target).parent().data('type');

        $('body').append(videoModalTpl).promise().done(() => {
            if (type == "video") {

                let videoHtml = `
                    <img src="/wp-content/themes/bioforce/dist/images/video-bg.png" alt="">
                    <iframe id="video"src="https://www.youtube.com/embed/`+ src + `?enablejsapi=1&html5=1&autoplay=1"></iframe>
                `;
                $('.media-modal .modal-body').html(videoHtml);

            } else {
                $('.media-modal .modal-body').html('<img src="' + src + '" class="img-fluid">');
            }
            $('.media-modal').modal('show');
            $('.media-modal').on('hidden.bs.modal', (e) => {
                if ($('.media-modal').find('video').length) {
                    $('.media-modal').find('video').get(0).pause();
                }
                $('.media-modal').remove();
            });
        });
    });
};

const paginationHandler = () => {

    $(document).on('click', '.pagination a', function (event) {
        // Stop the browser from submitting the form.
        event.preventDefault();

        let target = $(this).parents('.pagination').data('target');
        console.log($(this).parents('.pagination'));
        console.log(target);
        
        let id = $(event.target).data('page');
        let form = $('.filters form');

        if (!ajaxState) {
            let pageId = id;
            // send filter form
            form.trigger('submit', [pageId]);

            if (target !== 'undefined') {
                $('html, body').animate({
                    scrollTop: $(target).offset().top
                }, 500);
            }
            
        }
    });
};
const formationPostsCarrousel=()=> {

  let owl = $(".formations-list-posts");

  if (!owl.length > 1) return;

  $.each(owl, function () {

    $(this).owlCarousel({
      items: 1,
      loop: true,
      margin: 40,
    });

  });
};


const filterHandler = () => {
    let loader = '<div class="wait-loading"></div>';
    $('.filters form').submit(function(event, pageId)  {
        // Stop the browser from submitting the form.
        event.preventDefault();

        let target = $(this).parents('.filters').data('target');
        let htmlText = $(this).parents('.filters').data('noresult');
        console.log("htmlText", htmlText);
        if (!ajaxState) {
            ajaxState = true;
            $('body').append(loader);
            pageId = pageId == "undefined" ? 1 : pageId;
            $(this).find('input[name="page"]').val(pageId);
            let url = $(this).attr('action');
            let data = $(this).serialize();
            //let baseUrl = window.location.origin;
            //let data_url = data;
            //window.history.pushState({}, '', data_url.split(baseUrl)[1]);

            if($('.page-template-page-formations').length) {
                history.pushState(null, null, "?" + data);
            }

            $.get(url, data, (result) => {
                let obj = JSON.parse(result);
               
                let content = (obj.items == "") ? `<p class="no-result">${htmlText}</p>` : obj.items;
                $(target).html(content);
                if (window.matchMedia("(max-width: 640px)").matches) {
                  formationPostsCarrousel();
                }
            }).done(() => {
                ajaxState = false;
                $('.wait-loading').remove(); 
                
            });

            
                
        }


    });
};



window.onload = () => {
    if ($(".modal-plug").length) {
        $(".modal-plug").modal('show');
    }
};


$(document).ready(() => {
    searchHandler();
    mediaModal();
    filterHandler();
    paginationHandler();
});
